require('./webBanner.scss');

const CONTENT_WIDTH_DEFAULT = 600;
const TRACK_EVENTS = {
  DELIVERED: 'delivered',
  CLICKED: 'clicked',
};
const CLICK_BANNER_LOCAL_STORAGE_KEY = 'cleverpush-banner-opened';

export default class WebBanner {
  constructor(webBanner, config, subscriptionManager, api, log) {
    this.webBanner = webBanner;
    this.config = config;
    this.subscriptionManager = subscriptionManager;
    this.api = api;
    this.log = log;
    this.element = null;
    this.contentWidth = Math.min(this.webBanner.style.width || CONTENT_WIDTH_DEFAULT, window.innerWidth);
  }

  show() {
    this.element = document.createElement('div');
    this.element.className = 'cleverpush-banner';
    this.element.innerHTML = (`
      <div class="banner-content">
        <button type="button" class="banner-close">&times;</button>
        <iframe frameborder="0" scrolling="no" allowtransparency></iframe>
      </div>
    `);

    let appendElement = document.body;
    if (this.webBanner.appendToSelector) {
      appendElement = document.querySelector(this.webBanner.appendToSelector);
    } else {
      document.body.classList.add('cleverpush-banner-open');
    }

    if (this.webBanner.customCss) {
      const style = document.createElement('style');
      style.innerHTML = this.webBanner.customCss;
      document.head.appendChild(style);
    }

    if (appendElement) {
      appendElement.appendChild(this.element);

      this.closeButton = this.element.querySelector('.overlay-close');
      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.onCloseClick.bind(this));
      }

      this.content = this.element.querySelector('.banner-content');
      if (this.content) {
        let bannerHtml = this.webBanner.content || '';
        this.iframe = this.content.querySelector('iframe');
        const htmlContainsScript = bannerHtml.includes('<script');
        if (this.iframe) {
          bannerHtml += `
          <style>
            ${htmlContainsScript ? '' : `
              body, body > table {
                background-color: transparent !important;
              }
              html, body {
                height: 100%;
              }
            `}
            ${this.webBanner.customCss || ''}
          </style>

          <script${this.webBanner.scriptNonce ? ` nonce="${this.webBanner.scriptNonce}"` : ''}>
            var bannerId = '${this.webBanner._id}';
            var oncePerClickOnly = ${this.webBanner.oncePerClick};
            var closeBanners = function() {
              for (var bannerIndex = 0; bannerIndex < window.top.CleverPush.webBanners.length; bannerIndex++) {
                if (window.top.CleverPush.webBanners[bannerIndex].element) {
                  window.top.CleverPush.webBanners[bannerIndex].element.style.display = 'none';
                  window.top.document.body.classList.remove('cleverpush-banner-open');
                }
              }
            };

            var getBannerIndex = function(bannerId) {
              return window.top.CleverPush.webBanners.findIndex(function(doc) { return doc.webBanner._id === bannerId; });
            }

            var openStory = function(url) {
              for (var bannerIndex = 0; bannerIndex < window.top.CleverPush.webBanners.length; bannerIndex++) {
                if (window.top.CleverPush.webBanners[bannerIndex].element) {
                  var content = window.top.CleverPush.webBanners[bannerIndex].element.querySelector('.banner-content');
                  if (content) {
                    content.style.top = 0;
                    content.style.right = 0;
                    content.style.bottom = 0;
                    content.style.left = 0;
                    if (window.innerWidth < 768) {
                      content.style.paddingTop = 0;
                      content.style.paddingBottom = 0;
                    }
                    window.top.CleverPush.webBanners[bannerIndex].iframe.style.height = '100%';
                  }
                }
              }
              
              document.body.style.display = 'flex';
              document.body.style.alignItems = 'center';
              document.body.style.justifyContent = 'center';

              var mainTable = document.querySelector('body > table');
              if (mainTable) {
                mainTable.parentNode.removeChild(mainTable);
              }

              var script = document.createElement("script");
              var link = document.createElement("link");
              script.src = 'https://cdn.ampproject.org/amp-story-player-v0.js';
              script.async = true;
              script.onload = function() {
                var ASPECT_RATIO = 0.6;
                var playerEl = document.createElement('amp-story-player');
                var height = 600;
                var width = (height * ASPECT_RATIO) + 'px';

                if (window.innerWidth < 768) {
                  playerEl.style.width = '100%';
                  playerEl.style.height = '100%';
                } else {
                  playerEl.style.width = width;
                  playerEl.style.maxWidth = '100%';
                  playerEl.style.height = height + 'px';
                }
                playerEl.style.margin = '0 auto';

                document.body.appendChild(playerEl);

                var a = document.createElement('a');
                a.setAttribute('href', url);
                playerEl.appendChild(a);

                var player = new AmpStoryPlayer(window, playerEl);
                setTimeout(() => {
                  player.load();
                }, 0);
              };
              link.href = 'https://cdn.ampproject.org/amp-story-player-v0.css';
              link.rel = 'stylesheet';
              link.type = 'text/css';
              document.head.append(script, link);
            };

            var bannerCloseLinks = document.querySelectorAll('a[href="#close"]');
            for (var i = 0; i < bannerCloseLinks.length; i++) {
              bannerCloseLinks[i].addEventListener('click', function(e) {
                e.preventDefault();
                closeBanners();
              });
            }

            var openStoryLinks = document.querySelectorAll('a[href*="#open-story"]');
            for (var i = 0; i < openStoryLinks.length; i++) {
              openStoryLinks[i].addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                if (e.currentTarget) {
                  openStory(e.currentTarget.href.split('#')[0]);
                }
              });
            }

            var bannerButtons = document.querySelectorAll('a');
            for (var i = 0; i < bannerButtons.length; i++) {
              bannerButtons[i].addEventListener('click', function(e) {
                if (e.currentTarget && e.currentTarget.href.indexOf('#open-story') < 0) {
                  var bannerIndex = getBannerIndex(bannerId);
                  closeBanners();

                  var elementId;
                  var buttonElement = e.currentTarget.closest('[id^="element-"]');
                  if (buttonElement && buttonElement.id) {
                    elementId = buttonElement.id.split('-')[1];
                  }

                  const parentElement = e.target.parentElement;
                  if (parentElement && parentElement.id) {
                    elementId = parentElement.id.split('-')[1];
                  }
                  
                  if (oncePerClickOnly) {
                    window.top.CleverPush.webBanners[bannerIndex].saveBannerClick(bannerId);
                  }
                  var webBannerButtons = [];
                  var webBanner = window.top.CleverPush.webBanners[bannerIndex];
                  webBanner.webBanner.contentState.rows.forEach((row) => {
                    row.cols.forEach((col) => {
                      var buttons = col.elements.filter((webBannerButton) => webBannerButton.type === 'button');
                      webBannerButtons = webBannerButtons.concat(buttons);
                    });
                  });

                  var clickedButton = webBannerButtons.find((webBannerButton) => webBannerButton.id === elementId)
                 
                  if (clickedButton && !clickedButton.dontCountClickStatistics) {
                    window.top.CleverPush.api.trackWebBannerEvent('clicked', bannerId, elementId);
                  }
                }
                return true;
              });
            }
          </script>
          `;

          this.iframe.contentWindow.document.write(bannerHtml);
          this.iframe.contentWindow.document.close();

          let iframeHeightSet = 0;
          let previousHeight = 0;
          const setIframeHeight = () => {
            window.requestAnimationFrame(() => {
              if (this.iframe.style.height === '100%') {
                // could be set from story
                return;
              }

              if (this.iframe.contentWindow.document.body.scrollHeight !== previousHeight) {
                this.iframe.style.height = 0;
                this.iframe.style.height = `${this.iframe.contentWindow.document.body.scrollHeight}px`;
                previousHeight = this.iframe.contentWindow.document.body.scrollHeight;
              }
              iframeHeightSet += 1;
              if (iframeHeightSet < 300) { // 30 secs
                setTimeout(setIframeHeight, 100);
              }
            });
          };
          setIframeHeight();
        }
      }

      if (this.webBanner.darkenBackground) {
        this.element.style.backgroundColor = 'rgba(0,0,0,.75)';
      } else {
        this.element.style.pointerEvents = 'none';
        this.content.style.pointerEvents = 'initial';
      }

      this.content.style.backgroundColor = 'transparent';

      this.element.addEventListener('click', (e) => {
        if (e.target === e.currentTarget) {
          this.element.style.display = 'none';
          document.body.classList.remove('cleverpush-banner-open');
        }
      });

      if (typeof this.webBanner.style === 'object') {
        if (this.webBanner.style.align === 'top') {
          this.content.style.top = 0;
        }
        if (this.webBanner.style.align === 'bottom') {
          this.content.style.bottom = 0;
        }
        if (this.webBanner.style.align === 'left') {
          this.content.style.left = 0;
        }
        if (this.webBanner.style.align === 'right') {
          this.content.style.right = 0;
        }

        if (this.webBanner.style.align === 'top') {
          delete this.webBanner.style.bottom;

          if (this.webBanner.style.top) {
            this.content.style.maxHeight = `calc(100vh - ${this.webBanner.style.top}px)`;
          }
        }
        if (this.webBanner.style.align === 'bottom') {
          delete this.webBanner.style.top;

          if (this.webBanner.style.bottom) {
            this.content.style.maxHeight = `calc(100vh - ${this.webBanner.style.bottom}px)`;
          }
        }
        if (this.webBanner.style.align === 'left') {
          delete this.webBanner.style.right;
        }
        if (this.webBanner.style.align === 'right') {
          delete this.webBanner.style.left;
        }

        for (const property in this.webBanner.style) {
          if (this.webBanner.style.hasOwnProperty(property)) {
            let prop = this.webBanner.style[property];
            if (property === 'backgroundImage' && prop.indexOf('url(') < 0) {
              prop = `url(${prop})`;
            }
            this.content.style[property] = typeof prop === 'number' ? (`${prop}px`) : prop;
          }
        }

        if (!this.content.style.align || this.content.style.align === 'center') {
          this.content.style.margin = '50px auto 0';
          this.content.style.maxHeight = 'calc(100% - 100px)';
        }

        if (this.content.style.fullWidth) {
          this.content.style.width = '100%';
        } else if (!this.webBanner.style.align || this.webBanner.style.align === 'center') {
          this.content.style.left = '50%';
          this.content.style.width = `${this.contentWidth}px`;
          this.content.style.marginLeft = `${-1 * (this.contentWidth / 2)}px`;
        } else {
          this.content.style.width = `${this.contentWidth}px`;
        }
      }

      this.closeButton = this.element.querySelector('.banner-close');
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => {
          if (this.webBanner.oncePerClick) {
            this.saveBannerClick(this.webBanner._id);
          }
          this.element.style.display = 'none';
          document.body.classList.remove('cleverpush-banner-open');
        });
        this.closeButton.addEventListener('touchstart', () => {
          if (this.webBanner.oncePerClick) {
            this.saveBannerClick(this.webBanner._id);
          }

          this.element.style.display = 'none';
          document.body.classList.remove('cleverpush-banner-open');
        });

        if (this.webBanner.style && this.webBanner.style.color) {
          this.closeButton.style.color = this.webBanner.style.color;
        }
      }

      if (this.webBanner._id) {
        this.api.trackWebBannerEvent(TRACK_EVENTS.DELIVERED, this.webBanner._id);
      }
    }
  }

  onClick(e) {
    e.preventDefault();
    if (typeof this.onClickCallback === 'function') {
      this.onClickCallback();
    }

    if (this.webBanner._id) {
      this.api.trackWebBannerEvent(TRACK_EVENTS.CLICKED, this.webBanner._id);
    }

    this.element.style.display = 'none';
    document.body.classList.remove('cleverpush-banner-open');

    if (this.webBanner.buttonUrl) {
      try {
        const popup = window.open(this.webBanner.buttonUrl, '_blank');
        if (!popup) {
          location.href = this.webBanner.buttonUrl;
        }
      } catch (ignored) {
        location.href = this.webBanner.buttonUrl;
      }
    }
  }

  saveBannerClick = (bannerId) => {
    let bannerIds = [];
    if (localStorage.getItem(CLICK_BANNER_LOCAL_STORAGE_KEY)) {
      bannerIds = JSON.parse(localStorage.getItem(CLICK_BANNER_LOCAL_STORAGE_KEY));

      if (bannerIds.indexOf(bannerId) === -1) {
        bannerIds.push(bannerId);
      }
    } else {
      bannerIds.push(bannerId);
    }
    localStorage.setItem(CLICK_BANNER_LOCAL_STORAGE_KEY, JSON.stringify(bannerIds));
  }

  onCloseClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (typeof this.onClickCallback === 'function') {
      this.onClickCallback();
    }

    this.element.style.display = 'none';

    document.body.classList.remove('cleverpush-banner-open');
  }
}
